export const AREA_SORT_NUMBER_MIN = 0;
export const AREA_SORT_NUMBER_MAX = 1000;

/**
 * Parses `raw` only if it is the canonical decimal form of an integer (no `parseInt` truncation).
 * Rejects e.g. `12abc`, `12.3`, `1e2`, leading-zero forms like `012` (String(n) !== raw).
 */
export function parseStrictIntegerString(raw: string): number | undefined {
    if (raw === '') return undefined;
    const n = Number(raw);
    if (!Number.isInteger(n) || String(n) !== raw) return undefined;
    return n;
}

export function isValidAreaSortNumber(n: number): boolean {
    return Number.isInteger(n) && n >= AREA_SORT_NUMBER_MIN && n <= AREA_SORT_NUMBER_MAX;
}
